import {
  Field,
  Input,
  Label,
  Select,
  SelectOption,
} from "../../../components/forms";
import { ApiCompetition } from "../../../types";
import CategorySelect from "./CategorySelect";

type Props = {
  canChangeCategory: boolean;
  competition?: ApiCompetition;
  withAgeGender?: boolean;
  withProfile?: boolean;
  setCompetitorNumber?: (competitorNumber: string) => void;
  withCompetitorNumber?: boolean;
};

export default function EntryFormFields({
  canChangeCategory,
  competition,
  withProfile = true,
  withAgeGender = false,
  withCompetitorNumber = true,
  setCompetitorNumber,
}: Props) {
  return (
    <>
      {withCompetitorNumber && competition?.hasCompetitorNumbers ? (
        <Field name="competitorNumber">
          <Label>Competitor Number</Label>
          <Input
            type="numeric"
            onChange={(e) => setCompetitorNumber?.(e.currentTarget.value)}
          />
        </Field>
      ) : null}
      {withProfile ? (
        <>
          <Field name="firstName">
            <Label>First name</Label>
            <Input type="text" />
          </Field>
          <Field name="lastName">
            <Label>Last name</Label>
            <Input type="text" />
          </Field>
        </>
      ) : null}
      <Field name="category">
        <Label>Category</Label>
        <CategorySelect
          canChangeCategory={canChangeCategory}
          competition={competition}
        />
      </Field>
      {withProfile && withAgeGender ? (
        <>
          <Field name="yearOfBirth">
            <Label>Year of birth</Label>
            <Input type="text" inputMode="numeric" />
          </Field>
          <Field name="gender">
            <Label>Gender</Label>
            <Select>
              <SelectOption value="" disabled defaultValue="" hidden>
                Select gender...
              </SelectOption>
              <SelectOption value="MALE">Male</SelectOption>
              <SelectOption value="FEMALE">Female</SelectOption>
              <SelectOption value="OTHER">Other</SelectOption>
            </Select>
          </Field>
        </>
      ) : null}
    </>
  );
}
